<template>
  <div class="nav-container">
    <div class="nav-top-row">
      <div class="nav-top-left">
        <div class="logo-header cursor-pointer">
          <router-link to="/" class="logo" />
        </div>
        <q-badge v-if="url.indexOf('staging') > -1" class="staging-badge"
          >Staging</q-badge
        >
      </div>

      <div class="nav-top-right">
        <router-link :to="{ name: 'Login' }" class="navmenu-link">
          <q-btn
            label="Login"
            v-if="!isLoggedIn"
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
          >
          </q-btn>
        </router-link>

        <div class="row middle-section" v-if="isLoggedIn">
          <div
            class="notification-container"
            :class="totalUnseenCount > 0 ? 'has-unseen-notifs' : ''"
          >
            <i
              ref="bellIcon"
              class="las la-2x la-bell bell-btn"
              role="button"
              tabindex="0"
              :aria-label="notificationsAriaLabel"
              @click="togglePopover()"
              @keydown.enter.prevent="togglePopover()"
              @keydown.space.prevent="togglePopover()"
            ></i>
            <span class="icon-button__badge bold-font" aria-hidden="true">
              {{ totalUnseenCount }}
            </span>
          </div>
          <DxPopover
            :target="bellIcon"
            :visible="isPopoverVisible"
            hide-event="outsideClick"
            position="bottom"
            class="popover"
          >
            <template #content>
              <DxTabPanel
                item-template="tabPanelItem"
                :animation-enabled="true"
                :swipe-enabled="true"
                :items="tabs"
                :tabs-position="'top'"
                :styling-mode="'secondary'"
                :icon-position="'top'"
              >
                <template #tabPanelItem="{ data }">
                  <NotificationsList
                    :data="data.notifications"
                    :markNotificationAsSeen="data.markNotificationAsSeen"
                    :deleteNotification="data.deleteNotification"
                    :entityLabel="data.entityLabel"
                  />
                </template>
              </DxTabPanel>
            </template>
          </DxPopover>
        </div>

        <q-btn
          flat
          color="white"
          no-caps
          class="navmenu-link q-ml-sm logout-btn"
          :class="isUnderlined('logout')"
          icon="logout"
          label="Logout"
          v-if="isLoggedIn"
          @click="logout"
        >
        </q-btn>
      </div>

      <Slide right class="burger-menu">
        <div v-if="!isLoggedIn">
          <router-link :to="{ name: 'Login' }">
            <q-btn
              outline
              color="primary"
              label="Login"
              class="burgermenu-button full-width"
            >
            </q-btn>
          </router-link>
        </div>

        <router-link
          :to="{ name: 'TagTab', params: { tab: 'Audience' } }"
          v-if="isLoggedIn && isSuperAdmin"
        >
          <q-btn
            outline
            color="primary"
            label="Tags"
            class="burgermenu-button full-width"
          >
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'SchemesSearchPage' }" v-if="isLoggedIn">
          <q-btn
            outline
            color="primary"
            label="Schemes"
            class="burgermenu-button"
          >
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'News' }" v-if="isLoggedIn">
          <q-btn outline color="primary" label="News" class="burgermenu-button">
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'Organisations' }" v-if="isLoggedIn">
          <q-btn
            outline
            color="primary"
            label="Organisations"
            class="burgermenu-button"
          >
          </q-btn>
        </router-link>

        <router-link
          :to="{ name: 'News' }"
          class="navmenu-link"
          v-if="isLoggedIn"
        >
          <q-btn outline color="primary" label="News"> </q-btn>
        </router-link>
        <router-link :to="{ name: 'CustomersGrid' }" v-if="isLoggedIn">
          <q-btn
            outline
            color="primary"
            label="Customers"
            class="burgermenu-button"
          >
          </q-btn>
        </router-link>
        <router-link :to="{ name: 'UsersGrid' }" v-if="isLoggedIn">
          <q-btn
            outline
            color="primary"
            label="Users"
            class="burgermenu-button"
          >
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'AccountManagersGrid' }" v-if="isLoggedIn">
          <q-btn
            outline
            color="primary"
            label="Account managers"
            class="burgermenu-button"
          >
          </q-btn>
        </router-link>
        <q-btn-dropdown
          v-if="isLoggedIn"
          outline
          color="primary"
          label="VisualPing"
          class="burgermenu-button full-width"
          no-caps
        >
          <q-list>
            <q-item
              clickable
              v-close-popup
              :to="{ name: 'VisualPingLinks' }"
              @click="collapse"
            >
              <q-item-section>Links</q-item-section>
            </q-item>
            <q-item
              clickable
              v-close-popup
              :to="{ name: 'VisualPingData' }"
              @click="collapse"
            >
              <q-item-section>Data</q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
        <router-link
          :to="{ name: 'EditEmailTemplates' }"
          v-if="isLoggedIn && isSuperAdmin"
        >
          <q-btn
            outline
            color="primary"
            label="Email templates"
            class="burgermenu-button"
          >
          </q-btn>
        </router-link>

        <q-btn
          v-if="isLoggedIn"
          outline
          color="primary"
          label="Logout"
          class="burgermenu-button full-width"
          @click="logout"
        >
        </q-btn>
      </Slide>
    </div>

    <div class="nav-bottom-row" v-bind:class="{ show: isExpanded }">
      <div class="menu-buttons" style="margin-left: 132px">
        <router-link :to="{ name: 'GeneralStats' }" class="navmenu-link">
          <q-btn
            :class="isUnderlined('stats')"
            v-if="isLoggedIn"
            flat
            color="white"
            label="Stats"
            no-caps
            class="navmenu-link q-ml-sm"
          >
          </q-btn>
        </router-link>

        <router-link
          v-if="isSuperAdmin || canSetAIAssistantVisibility"
          :to="{ name: 'AISettings' }"
          class="navmenu-link"
        >
          <q-btn
            :class="isUnderlined('ai-settings')"
            label="AI Settings"
            v-if="isLoggedIn"
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
          >
          </q-btn>
        </router-link>
        <router-link :to="{ name: 'GlobalSettings' }" class="navmenu-link">
          <q-btn
            :class="isUnderlined('global-settings')"
            label="Global settings"
            v-if="isLoggedIn"
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
          >
          </q-btn>
        </router-link>
        <router-link
          v-if="isSuperAdmin"
          :to="{ name: 'TagTab', params: { tab: 'Audience' } }"
          class="navmenu-link"
        >
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('tags')"
            label="Tags"
            v-if="isLoggedIn"
          >
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'SchemesSearchPage' }" class="navmenu-link">
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('schemes')"
            label="Schemes"
            v-if="isLoggedIn"
          >
          </q-btn>
        </router-link>

        <router-link
          v-if="isLoggedIn && canManageSchemes"
          :to="{ name: 'EuCallSchemeMapping' }"
          class="navmenu-link"
        >
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('eu-call-scheme-mapping')"
            label="EU call mapping"
          >
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'News' }" class="navmenu-link">
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('news')"
            label="News"
            v-if="isLoggedIn"
          >
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'Organisations' }" class="navmenu-link">
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('organisations')"
            label="Organisations"
            v-if="isLoggedIn"
          >
          </q-btn>
        </router-link>
        <router-link :to="{ name: 'CustomersGrid' }" class="navmenu-link">
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('customers')"
            label="Customers"
            v-if="isLoggedIn"
          >
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'UsersGrid' }" class="navmenu-link">
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('users')"
            label="Users"
            v-if="isLoggedIn"
          >
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'AccountManagersGrid' }" class="navmenu-link">
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('account-managers')"
            label="Account managers"
            v-if="isLoggedIn"
          >
          </q-btn>
        </router-link>
        <q-btn-dropdown
          flat
          color="white"
          no-caps
          class="navmenu-link q-ml-sm"
          :class="isUnderlined('visualping')"
          label="VisualPing"
          v-if="isLoggedIn"
        >
          <q-list>
            <q-item clickable v-close-popup :to="{ name: 'VisualPingLinks' }">
              <q-item-section>Links</q-item-section>
            </q-item>
            <q-item clickable v-close-popup :to="{ name: 'VisualPingData' }">
              <q-item-section>Data</q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>

        <router-link :to="{ name: 'EditEmailTemplates' }" class="navmenu-link">
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('edit-templates')"
            label="Email templates"
            v-if="isLoggedIn && isSuperAdmin"
          >
          </q-btn>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from "axios";
import * as signalR from "@microsoft/signalr";
import { Slide } from "vue3-burger-menu";
import store from "../store/index.js";
import { useRoute, useRouter } from "vue-router";
import { ref, computed, onUnmounted, watch } from "vue";
import authService from "../services/auth.service.js";
import notificationsService from "../services/notifications.service.js";
import euCallNotificationsService from "../services/euCallNotifications.service.js";
import axiosUrl from "../services/axios.service.js";
import { DxPopover } from "devextreme-vue/popover";
import DxTabPanel from "devextreme-vue/tab-panel";
import NotificationsList from "../components/notifications-components/NotificationsList.vue";

const API_URL = axiosUrl.getAxiosUrl();
const hubEventName = "ReceiveAiSchemeCreationNotification";
const route = useRoute();
const router = useRouter();

const isExpanded = ref(false);
const isPopoverVisible = ref(false);
const bellIcon = ref(null);
const connection = ref(null);
const url = window.location.href;

const isLoggedIn = computed(() => store.state.auth.isLoggedIn);
const isSuperAdmin = computed(() => !!store.state.auth.authUser?.isSuperAdmin);
const canManageSchemes = computed(
  () => !!store.state.auth.authUser?.canManageSchemes
);

const seenNotificationsList = computed(
  () => store.state.notifications.schemeCreationNotifications.seenNotifications
);

const unseenNotificationsList = computed(
  () =>
    store.state.notifications.schemeCreationNotifications.unseenNotifications
);

const euSeenNotificationsList = computed(
  () => store.state.notifications.euCallNotifications.seenNotifications
);

const euUnseenNotificationsList = computed(
  () => store.state.notifications.euCallNotifications.unseenNotifications
);

const totalUnseenCount = computed(
  () =>
    unseenNotificationsList.value.length + euUnseenNotificationsList.value.length
);

const notificationsAriaLabel = computed(() =>
  totalUnseenCount.value > 0
    ? `Notifications, ${totalUnseenCount.value} unread`
    : "Notifications, no unread"
);

const tabs = computed(() => [
  {
    title: "Unseen notifications",
    component: NotificationsList,
    notifications: unseenNotificationsList.value,
    markNotificationAsSeen: markNotificationAsSeen,
    deleteNotification: deleteNotification,
    entityLabel: "scheme"
  },
  {
    title: "Seen notifications",
    component: NotificationsList,
    notifications: seenNotificationsList.value,
    markNotificationAsSeen: markNotificationAsSeen,
    deleteNotification: deleteNotification,
    entityLabel: "scheme"
  },
  {
    title: "EU calls (unseen)",
    component: NotificationsList,
    notifications: euUnseenNotificationsList.value,
    markNotificationAsSeen: markEuNotificationAsSeen,
    deleteNotification: deleteEuNotification,
    entityLabel: "call"
  },
  {
    title: "EU calls (seen)",
    component: NotificationsList,
    notifications: euSeenNotificationsList.value,
    markNotificationAsSeen: markEuNotificationAsSeen,
    deleteNotification: deleteEuNotification,
    entityLabel: "call"
  }
]);

const togglePopover = () => {
  isPopoverVisible.value = !isPopoverVisible.value;
};

const triggerShake = () => {
  if (bellIcon.value) {
    bellIcon.value.classList.add("shake");
    setTimeout(() => bellIcon.value.classList.remove("shake"), 800);
  }
};

const collapse = () => {
  isExpanded.value = false;
};

const logout = async () => {
  await authService.logout(true);
  router.push({ name: "Login" });
};

const isUnderlined = buttonRoute => {
  if (route.fullPath.includes(buttonRoute)) {
    return "btn-nav-underlined";
  }

  return "";
};

const handleNotificationsError = error => {
  const errorMessage = error?.response?.data ?? "Unable to load notifications.";
  store.commit("notifications/updateModalError", errorMessage);
  store.commit("notifications/enableModalError");
};

const notificationsApiBaseUrl = process.env.VUE_APP_API_BASE_URL;

const loadNotifications = async () => {
  try {
    const response = await axios.get(
      `${API_URL}notifications/getAllNotifications`
    );
    store.commit(
      "notifications/updateSchemeCreationNotifications",
      response.data
    );
  } catch (error) {
    handleNotificationsError(error);
  }
};

const loadEuNotifications = async () => {
  try {
    const response = await axios.get(
      `${API_URL}euCallNotifications/getAllNotifications`
    );
    store.commit("notifications/updateEuCallNotifications", response.data);
  } catch (error) {
    handleNotificationsError(error);
  }
};

// Loads both notification streams and shakes the bell when the combined unseen count grew.
const loadAllNotifications = async ({ triggerBell = false } = {}) => {
  const previousUnseenCount = totalUnseenCount.value;

  await Promise.all([loadNotifications(), loadEuNotifications()]);

  if (triggerBell && totalUnseenCount.value > previousUnseenCount) {
    triggerShake();
  }
};

const startNotificationsHub = async () => {
  if (!isLoggedIn.value || connection.value) {
    return;
  }
  connection.value = new signalR.HubConnectionBuilder()
    .withUrl(`${notificationsApiBaseUrl}/aiSchemeCreationNotificationsHub`)
    .configureLogging(signalR.LogLevel.Information)
    .withAutomaticReconnect()
    .build();

  try {
    await connection.value.start();
  } catch (error) {
    console.error("Error establishing SignalR connection:", error);
  }

  connection.value.on(hubEventName, async () => {
    await loadAllNotifications({ triggerBell: true });
  });
};

const stopNotificationsHub = async () => {
  if (!connection.value) {
    return;
  }

  connection.value.off(hubEventName);
  await connection.value.stop();
  connection.value = null;
};

const markNotificationAsSeen = async notificationId => {
  await notificationsService.markNotificationAsSeen(notificationId);
  await loadNotifications();
};

const deleteNotification = async notificationId => {
  await notificationsService.deleteNotification(notificationId);
  await loadNotifications();
};

const markEuNotificationAsSeen = async notificationId => {
  await euCallNotificationsService.markNotificationAsSeen(notificationId);
  await loadEuNotifications();
};

const deleteEuNotification = async notificationId => {
  await euCallNotificationsService.deleteNotification(notificationId);
  await loadEuNotifications();
};

// EU-call notifications are produced by a background job (no live SignalR push), so poll periodically
// to keep the bell count current while the user stays logged in.
const POLL_INTERVAL_MS = 120000;
let pollHandle = null;

const startPolling = () => {
  if (pollHandle) {
    return;
  }
  pollHandle = setInterval(() => {
    loadAllNotifications({ triggerBell: true });
  }, POLL_INTERVAL_MS);
};

const stopPolling = () => {
  if (!pollHandle) {
    return;
  }
  clearInterval(pollHandle);
  pollHandle = null;
};

watch(
  isLoggedIn,
  async loggedIn => {
    if (!loggedIn) {
      stopPolling();
      await stopNotificationsHub();
      return;
    }

    await loadAllNotifications();
    await startNotificationsHub();
    startPolling();
  },
  { immediate: true }
);

onUnmounted(async () => {
  stopPolling();
  await stopNotificationsHub();
});
</script>

<style scoped lang="scss">
.has-unseen-notifs {
  > .icon-button__badge {
    color: white;
    background-color: red !important;
  }
}

.icon-button__badge {
  position: absolute;
  top: 1px;
  right: 0px;
  left: 15px;
  width: 20px;
  height: 20px;
  background: white;
  color: #25408f !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

@media screen and (min-width: 1744px) {
  .icon-button__badge {
    top: -10px !important;
  }
}

.notification-container {
  position: relative;
}

.popover {
  position: absolute !important;
  z-index: 1000;
  width: 340px;
  left: 50%;
  transform: translateX(-50%);
}

.bell-btn {
  transition: transform 0.2s ease-in-out;
  color: white;
}
.bell-btn.shake {
  animation: shake 0.5s;
}

@keyframes shake {
  0%,
  100% {
    transform: rotate(0);
  }
  20%,
  60% {
    transform: rotate(-15deg);
  }
  40%,
  80% {
    transform: rotate(15deg);
  }
}

.middle-section {
  width: max-content;
  display: flex;
  .notification-container {
    display: flex;
    width: min-content;
    align-items: center;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
